/* istanbul ignore file */
import { palette } from '@noths/polaris-design-system-theme-brand2026customer';
import type { RuleSet } from 'styled-components';
import { css } from 'styled-components';

import type { ButtonTextColorMode } from 'client-ribbons-design-system/components/elements/Button/types';

export const buttonReset = css`
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

export const baseStyles = css`
  text-align: center;
`;

export const baseLink = css`
  ${baseStyles}
  text-decoration: none;
  display: inline-block;
`;

export const baseButton = css`
  ${buttonReset}
  ${baseStyles}
  &:disabled {
    pointer-events: none;
  }
`;

export const buttonContentTextColor: Record<ButtonTextColorMode, RuleSet<object>> = {
  brand: css`
    color: ${palette.deepPurpleBase};
  `,
  dark: css`
    color: ${palette.deepPurpleBase};
  `,
  light: css`
    color: var(--neutral-white-base);
  `,
};
